import { Card, CardContent } from '@travellegacy/nexops-design-system';
import { Badge } from '@travellegacy/nexops-design-system';
import { MessageCircle, TrendingUp, AlertCircle, Target } from 'lucide-react';
import type { MicroFeedback } from '../types';
import { formatDistanceToNow } from 'date-fns';
import { ptBR } from 'date-fns/locale';

interface FeedbackCardProps {
  feedback: MicroFeedback;
}

const feedbackTypeConfig = {
  RECOGNITION: {
    label: 'Reconhecimento',
    icon: MessageCircle,
    color: 'bg-green-100 dark:bg-green-950/40 text-green-800 dark:text-green-400',
  },
  DEVELOPMENT: {
    label: 'Desenvolvimento',
    icon: TrendingUp,
    color: 'bg-blue-100 dark:bg-blue-950/40 text-blue-800 dark:text-blue-400',
  },
  CORRECTION: {
    label: 'Correção',
    icon: AlertCircle,
    color: 'bg-yellow-100 dark:bg-yellow-950/40 text-yellow-800 dark:text-yellow-400',
  },
  ALIGNMENT: {
    label: 'Alinhamento',
    icon: Target,
    color: 'bg-purple-100 dark:bg-purple-950/40 text-purple-800 dark:text-purple-400',
  },
};

/**
 * Card para exibir um micro-feedback
 */
export function FeedbackCard({ feedback }: FeedbackCardProps) {
  const config = feedbackTypeConfig[feedback.type];
  const Icon = config.icon;

  return (
    <Card className="hover:shadow-md transition-shadow">
      <CardContent className="pt-4">
        <div className="flex items-start gap-3">
          <div className={`p-2 rounded-lg ${config.color}`}>
            <Icon className="h-5 w-5" />
          </div>

          <div className="flex-1">
            <div className="flex items-center gap-2 mb-2">
              <Badge variant="outline">{config.label}</Badge>
              {feedback.visibility === 'PRIVATE' && (
                <Badge variant="outline" className="text-xs">
                  Privado
                </Badge>
              )}
              <span className="text-xs text-muted-foreground ml-auto">
                {formatDistanceToNow(new Date(feedback.createdAt), {
                  addSuffix: true,
                  locale: ptBR,
                })}
              </span>
            </div>

            <p className="text-sm font-medium text-foreground mb-1">
              Para: {feedback.toEmployee.user.name}
            </p>

            <p className="text-sm text-foreground">{feedback.content}</p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
